export default "__VITE_ASSET__abb25fa9__"